import { GroupHealth, MilestoneStatus, StageStatus } from '@models';

const MILESTONE_VIEWER_TOOLTIP_LEGENDS = [
  {
    label: 'Upcoming',
    icon: 'arrow-right-circle',
    iconColor: '#70707A',
    description: 'Tasks scheduled for the future.',
    barIcon: 'bar-upcoming',
    barAltText: null
  },
  {
    label: 'Completed',
    icon: 'checked-circle-bold',
    iconColor: '#005DAA',
    description: 'Tasks that have been finished.',
    barIcon: 'bar-completed',
    barAltText: null
  },
  {
    label: 'In progress/On track',
    icon: 'like',
    iconColor: '#01891E',
    description: 'Work ongoing or milestone on track.',
    barIcon: 'bar-in-progress',
    barAltText: null
  },
  {
    label: 'Past due',
    icon: 'exclamation-circle-bold',
    iconColor: '#B60150',
    description: 'Work is overdue and needs attention.',
    barIcon: 'bar-past-due',
    barAltText: null
  },
  {
    label: 'At risk',
    icon: 'warning-bold',
    iconColor: '#D14700',
    description: 'Delays may impact progress.',
    barIcon: null,
    barAltText: '*only applies to milestones'
  }
];

const MILESTONE_STATUS_TO_ICON: Record<MilestoneStatus, { icon: string; color: string }> = {
  'Completed | Accelerated': { icon: 'checked-circle-bold', color: '#005DAA' },
  Completed: { icon: 'checked-circle-bold', color: '#005DAA' },
  'Completed | Late': { icon: 'checked-circle-bold', color: '#005DAA' },
  'Completed | On Time': { icon: 'checked-circle-bold', color: '#005DAA' },
  'Past Due': { icon: 'exclamation-circle-bold', color: '#B60150' },
  'On Track': { icon: 'like', color: '#01891E' },
  'At Risk': { icon: 'warning-bold', color: '#D14700' },
  Upcoming: { icon: 'arrow-right-circle', color: '#70707A' }
};

const STAGE_STATUS_TO_ICON: Record<StageStatus, { icon: string; color: string }> = {
  'In Progress': { icon: 'like', color: '#01891E' },
  Complete: { icon: 'checked-circle-bold', color: '#005DAA' },
  Upcoming: { icon: 'arrow-right-circle', color: '#70707A' }
};

const GROUP_HEALTH_TO_ICON: Record<GroupHealth, { icon: string; color: string }> = {
  IN_PROGRESS_PAST_DUE: { icon: 'exclamation-circle-bold', color: '#B60150' },
  IN_PROGRESS: { icon: 'like', color: '#01891E' },
  COMPLETED: { icon: 'checked-circle-bold', color: '#005DAA' },
  NOT_STARTED: { icon: 'arrow-right-circle', color: '#70707A' }
};

export {
  GROUP_HEALTH_TO_ICON,
  MILESTONE_STATUS_TO_ICON,
  MILESTONE_VIEWER_TOOLTIP_LEGENDS,
  STAGE_STATUS_TO_ICON
};
